import styled from "vue-styled-components";

const ImageIndicatorText = styled.span`
  color: white;
  font-size: 13px;
  font-weight: 400;
`;

export default ImageIndicatorText;
